export default {
  updateDate: '更新日期',
  status: '绑定状态',
  plant: '仓库代码',
  platformOrderNo: '平台销售订单号',
  giOrderNo: 'GI销售订单号',
  bzOmsOrderNo: '宝尊OMS销售订单号',
  rfidEpc: 'RFID EPC',
  carrierTrackingNo: '物流运单号',
  requiredBingQty: '系统需求绑定数量',
  actualTotalBinds: '实际已绑定数量',
  rfidBinds: 'RFID绑定总量',
  qrBinds: 'QR绑定总量',
  definition1: `
    <b>状态灯（左侧）</b>: 
    蓝色：产品绑定中；绿色 - 产品已绑定；灰色：产品已解绑。`,
  definition2: `
    <b>RFID EPC/QR Code删除线</b>: 
    该产品与订单号已解绑。`
}
